import { Card, Col, Table } from 'antd';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { type ApplicationListDataFragment } from '../../../api/fragments/ApplicationListData';
import LoadingElement from '../../../components/LoadingElement';
import { useDashboardContext } from './DashboardContext';
import useLatestApplicationTableData from './data/useLatestApplicationTableData';
import useStatusDescriptionModal from './data/useStatusDescriptionModal';

export const LatestApplicationTableViewID = 'latestApplicationTable';

const LatestApplicationTable = () => {
    const { t } = useTranslation(['applicationList', 'dashboard']);
    const statusDescriptionModal = useStatusDescriptionModal(t);
    const { isLoading, error, columns, data } = useLatestApplicationTableData(statusDescriptionModal.open);

    const navigate = useNavigate();

    const onRow = useCallback(
        (record: ApplicationListDataFragment) => ({
            onClick: () => {
                navigate(`/admin/applications/${record.id}`);
            },
        }),
        [navigate]
    );

    const { setVisible } = useDashboardContext();

    useEffect(() => {
        setVisible({ [LatestApplicationTableViewID]: !error });
    }, [error, setVisible]);

    if (isLoading) {
        return <LoadingElement />;
    }

    if (error) {
        return null;
    }

    return (
        <Col span={24}>
            <Card title={t('dashboard:latestApplicationTable.title')}>
                <Table
                    columns={columns}
                    dataSource={data}
                    onRow={onRow}
                    pagination={false}
                    scroll={{ x: true }}
                    size="small"
                />
                {statusDescriptionModal.render()}
            </Card>
        </Col>
    );
};

export default LatestApplicationTable;
